import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const ExportFileIcon: TIconType = (props?: IIconProps) => {
	const width = props?.width || '24';
	const height = props?.height || '24';
	const color = props?.color || colors.indigo70;

	return (
		<svg
			data-testid='export-icon'
			fill='none'
			height={height}
			viewBox='0 0 24 24'
			width={width}
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_26509_17877)'>
				<path
					d='M17 12L12 17L7 12'
					stroke={color}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M12 3L12 17'
					stroke={color}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M20 20L4 20'
					stroke={color}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_26509_17877'>
					<rect
						fill='white'
						height={height}
						width={width}
					/>
				</clipPath>
			</defs>
		</svg>

	);
};

export default ExportFileIcon;
